import React, { useState } from "react";
import { toast } from "sonner";
import { CalendarClock } from "lucide-react";
import api from "../../lib/api";
import { inputCls, Field, Panel, btnPrimary, btnSecondary, errMsg } from "./ui";

const localValue = (d) => {
  const x = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return x.toISOString().slice(0, 16);
};

export default function MaintenanceSchedule({ data, onChange }) {
  const [start, setStart] = useState(localValue(new Date(Date.now() + 60 * 60000)));
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/admin/maintenance/schedule", { start_at: new Date(start).toISOString(), message });
      toast.success("Maintenance dijadwalkan, pembeli melihat hitung mundur");
      window.dispatchEvent(new Event("mql:maintenance-refresh"));
      onChange();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const cancel = async () => {
    if (!window.confirm("Batalkan jadwal maintenance?")) return;
    try {
      await api.delete("/admin/maintenance/schedule");
      toast.success("Jadwal dibatalkan");
      window.dispatchEvent(new Event("mql:maintenance-refresh"));
      onChange();
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <Panel title="Jadwal Maintenance" testId="maintenance-schedule-panel">
      {data.scheduled_at ? (
        <div className="flex flex-col sm:flex-row sm:items-center gap-3">
          <div data-testid="maintenance-schedule-current" className="flex-1 text-sm text-[#F5F3ED]">
            <div className="flex items-center gap-2 text-[#D4AF37] font-bold"><CalendarClock size={16} /> {new Date(data.scheduled_at).toLocaleString()}</div>
            <div className="text-xs text-[#A8A8AD] mt-1">Dijadwalkan oleh {data.scheduled_by}{data.scheduled_message ? ` · "${data.scheduled_message}"` : ""}. Pembeli melihat banner hitung mundur; saat waktunya tiba situs ditutup otomatis dan backup dibuat.</div>
          </div>
          <button data-testid="maintenance-schedule-cancel-btn" onClick={cancel} className={btnSecondary}>Batalkan Jadwal</button>
        </div>
      ) : data.enabled ? (
        <p className="text-sm text-[#A8A8AD]">Maintenance sedang aktif. Matikan dulu untuk membuat jadwal baru.</p>
      ) : (
        <form onSubmit={save} className="flex flex-col md:flex-row gap-4 md:items-end">
          <Field label="Mulai (waktu lokal Anda)" className="md:w-60">
            <input data-testid="maintenance-schedule-input" type="datetime-local" required className={inputCls} value={start} onChange={(e) => setStart(e.target.value)} />
          </Field>
          <Field label="Pesan banner (opsional)" className="flex-1">
            <input data-testid="maintenance-schedule-message-input" maxLength={300} className={inputCls} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Mis. Upgrade sistem, perkiraan 1 jam" />
          </Field>
          <button data-testid="maintenance-schedule-save-btn" type="submit" disabled={busy} className={btnPrimary}>{busy ? "Menyimpan..." : "Jadwalkan"}</button>
        </form>
      )}
    </Panel>
  );
}
